var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Combo Check'}}),_c('combo-check-items',{attrs:{"allow-marking":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }